// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__1BZfO","rowsWrapper":"style_rowsWrapper__nZymb","rowWrapper":"style_rowWrapper__3JlnW","text":"style_text__uKFm1"};